'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponCodes = function CouponCodes(_ref) {
    var theme = _ref.theme,
        title = _ref.title,
        discounts = _ref.discounts;

    var id = 0;
    var list = discounts.map(function (offer) {
        return _react2.default.createElement(
            'li',
            { key: id++ },
            _react2.default.createElement(
                'a',
                { href: offer.link },
                _react2.default.createElement(
                    'h4',
                    null,
                    offer.text
                )
            )
        );
    });

    return _react2.default.createElement(
        'section',
        { className: theme.root },
        _react2.default.createElement(
            'h3',
            { className: theme.title },
            title
        ),
        _react2.default.createElement(
            'ul',
            null,
            list
        )
    );
};

CouponCodes.propTypes = {
    title: _propTypes2.default.string.isRequired,
    discounts: _propTypes2.default.array.isRequired, // eslint-disable-line react/forbid-prop-types
    theme: _propTypes2.default.shape({
        title: _propTypes2.default.string
    }).isRequired
};

CouponCodes.defaultProps = {
    title: 'Rabattkoder',
    discounts: {},
    theme: {}
};

exports.default = CouponCodes;
//# sourceMappingURL=CouponCodes.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/coupon-codes/lib/cjs/CouponCodes/CouponCodes.js
 ** module id = 716
 ** module chunks = 1
 **/